import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { DISH_TYPE_NODE_FRAGMENT } from '../fragments'

const SAVE_DISH_TYPES_MUTATION = gql`
  mutation saveDishTypes($data: [DishTypeNodeInput!]!) {
    saveDishTypes(data: $data) {
      results {
        ...DishTypeNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${DISH_TYPE_NODE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default SAVE_DISH_TYPES_MUTATION
